import { Component, OnInit, Input, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { InteractorService } from 'src/app/core/services/interactor.service';
import { LookupService } from 'src/app/core/services/lookup.service';
@Component({
  selector: 'app-confimation-popup',
  templateUrl: './confimation-popup.component.html',
  styleUrls: ['./confimation-popup.component.scss']
})
export class ConfimationPopupComponent implements OnInit {
  modalRef: BsModalRef;
  @Input() Message: string;
  @Input() ConfirmButton: string;
  @Input() DisCardButton: string;
  @Input() Header: string;
  @Output() modalEvent = new EventEmitter<boolean>();
  @ViewChild('template') elementView: TemplateRef<any>;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  btnDelete=this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover;
  constructor(
     private modalService: BsModalService,
     private interactorService: InteractorService,
     private translatorService: TranslateService,
     private lookupService: LookupService
     ) {
      this.translatorService.setDefaultLang('en');
      this.translatorService.use(localStorage.getItem('lang') || 'en');
     }

  ngOnInit(): void {
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);
      }
      this.setBackgroundColors();
    });
    document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);
  }

  /**
   * Function to open modal
   */
  public openModal() {
    this.updateModalStatus(true);
    this.modalRef = this.modalService.show(this.elementView, {
      class: 'modal-dialog-centered',
    });
  }

  /**
   * Function to close modal and emit event
   */
  public confirm(value) {
    this.updateModalStatus(false);
    this.modalEvent.emit(value);
    this.modalRef.hide();
  }
  setBackgroundColors(){
    this.btnDelete=this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover;
  }
  updateModalStatus(value) {
  if(window?.location?.pathname.includes('/people/details')){
     this.lookupService.updateActiveModalState(value);
    }
  }
}
